export enum PaymentMethod {
  CreditPaid = 1,
  Prepaid = 2,
  Barter = 3,
  Internal = 4,
}
